import { useSelector } from 'react-redux';
import { getToken } from '../../services/auth/auth.slice';

const useAuthCheck = () => {
  const token = useSelector(getToken);
  return { token };
};

export default useAuthCheck;
